import defaultTheme from 'tailwindcss/defaultTheme';
const transforms = {
    rotate: {
        ...defaultTheme.rotate,
        // '-180': '-180deg', // default
        '-135': '-135deg',
        // '-90': '-90deg',  // default
        // '-45': '-45deg',  // default
        // '-12': '-12deg',  // default
        // '-6': '-6deg',  // default
        // '-3': '-3deg',  // default
        // '-2': '-2deg',  // default
        // '-1': '-1deg',  // default
        // 0: '0',  // default
        // 1: '1deg',  // default
        // 2: '2deg',  // default
        // 3: '3deg',  // default
        // 6: '6deg',  // default
        // 12: '12deg',  // default
        // 45: '45deg',  // default
        // 90: '90deg',  // default
        135: '135deg'
        // 180: '180deg', // default
    }
};
export default transforms;
